<template>
  <div class="timer">
    <div class="day">
      <div>
        <span v-for="(day, index) in splitDays" :key="day + index" class="number">{{ day }}</span>
      </div>
      <p v-if="formatter" class="format">{{ wordString.day }}</p>
    </div>
    <div class="hour">
      <div>
        <span v-for="(hour, index) in splitHours" :key="hour + index" class="number">{{ hour }}</span>
      </div>
      <p v-if="formatter" class="format">{{ wordString.hour }}</p>
    </div>
    <div class="min">
      <div>
        <span v-for="(minute, index) in splitMinutes" :key="minute + index" class="number">{{ minute }}</span>
      </div>
      <p v-if="formatter" class="format">{{ wordString.minutes }}</p>
    </div>
    <div class="sec">
      <div>
        <span v-for="(second, index) in splitSeconds" :key="second + index" class="number">{{ second }}</span>
      </div>
      <p v-if="formatter" class="format">{{ wordString.seconds }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MmpTimer',
  props: {
    starttime: {
      type: String,
      default: () => { return this.$moment().format('YYYYMMDDHHmm') }
    },
    endtime: {
      type: String,
      default: () => { return this.$moment().add(1, 'days').format('YYYYMMDDHHmm') }
    },
    formatter: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      timer: '',
      start: '',
      end: '',
      interval: '',
      days: '',
      minutes: '',
      hours: '',
      seconds: '',
      wordString: {
        'day': 'DAYS',
        'hour': 'HRS',
        'minutes': 'MINS',
        'seconds': 'SECS'
      }
    }
  },
  computed: {
    splitDays () {
      const days = this.days.toString().split('')
      return this.days < 10 ? [0, ...days] : [...days]
    },
    splitHours () {
      const hours = this.hours.toString().split('')
      return this.hours < 10 ? [0, ...hours] : [...hours]
    },
    splitMinutes () {
      const minutes = this.minutes.toString().split('')
      return this.minutes < 10 ? [0, ...minutes] : [...minutes]
    },
    splitSeconds () {
      const seconds = this.seconds.toString().split('')
      return this.seconds < 10 ? [0, ...seconds] : [...seconds]
    }
  },
  created: function () {
  },
  mounted () {
    this.start = this.$moment().toDate().getTime()

    // var now = this.$moment().toDate().getTime()
    // this.start = this.$moment(this.starttime, 'YYYYMMDDHHmm').toDate().getTime()
    // if (now < this.start) {
    //   this.start = now
    // }

    this.end = this.$moment(this.endtime, 'YYYYMMDDHHmm').toDate().getTime()
    // Update the count down every 1 second
    this.timerCount(this.start, this.end)
    this.interval = setInterval(() => {
      this.timerCount(this.start, this.end)
    }, 1000)
  },
  methods: {
    timerCount: function (start, end) {
      // Get todays date and time
      var now = new Date().getTime()

      // Find the distance between now an the count down date
      var distance = start - now
      var passTime = end - now

      if (distance < 0 && passTime < 0) {
        clearInterval(this.interval)
      } else if (distance < 0 && passTime > 0) {
        this.calcTime(passTime)
      } else if ( distance > 0 && passTime > 0 ) {
        this.calcTime(distance)
      }
    },
    calcTime: function (dist) {
      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24))
      this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000)
    }
  }
}
</script>

<style lang="postcss" scoped>
 .timer {
   display: flex;
   justify-content: center;
   align-items: center;

  & .day,
  & .hour,
  & .min,
  & .sec {

    &:not(:last-child) {
      margin-right: 45px;
    }

    &:matches(:nth-child(3), :nth-child(4)) > div {
      position: relative;
      &:before {
        content: ':';
        display: inline-block;
        position: absolute;
        left: -33px;
        top: 0;
        font-size: 70px;
        color: rgba(0, 0, 0, .9);
      }
    }

    &:first-child  {
      margin-right: 0;
    }

    &:first-child > div {
      &:after {
        content: '일';
        display: inline-block;
        margin: 0 15px;
        font-size: 55px;
        color: #fff;
        vertical-align: bottom;
      }
    }
  }

  & .number {
    display: inline-block;
    padding: 18px 20px;
    position: relative;
    background-color: rgba(0, 0, 0, .9);
    border-radius: 8px;
    font-size: 64px;
    font-weight: 500;
    color:#fff;
    text-align: center;
    line-height: 1;

    &:not(:last-child) {
      margin-right: 8px;
    }
  }

  & .format {
    margin-top: 40px;
    font-size: 32px;
    font-weight: 500;
    color:#fff;
    text-align: center;
    line-height: 1;
  }

  @media (--mobile-viewport) {
  & .day,
  & .hour,
  & .min,
  & .sec {
    &:not(:last-child) {
      margin-right: 11px;
    }

    & > div {
      display: flex;
    }

    &:matches(:nth-child(3), :nth-child(4)) > div {
      &:before {
        left: -10px;
        font-size: 30px;
      }
    }

    &:first-child  {
      margin-right: 0;
    }

    &:first-child > div {
      &:after {
        margin: 0 7px;
        font-size: 20px;
        align-self: flex-end;
        line-height: 1.8;
      }
    }
  }

  & .number {
    padding: 10px 7px;
    font-size: 30px;

    &:not(:last-child) {
      margin-right: 4px;
    }

       &:after {
        height: 6px;
      }

  }

  & .format {
    margin-top: 14px;
    font-size: 13px;
  }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/_common/mmp-timer/MmpTimer.vue